import React from 'react';
import { Box, IconButton } from '@mui/material';
import { getIn, useFormikContext } from 'formik';
import { ReactComponent as DeleteIcon } from '../../assets/delete-icon.svg';
import IconSelector from '../../pages/KindergartenDetails/components/EventTab/OptionIconSelector/OptionIconSelector';
import { LanguageCodeEnum } from '../../common/enums/common.enum';
import { FormValues } from '../../pages/KindergartenDetails/components/EventTab/CreateConfiguration/CreateConfiguration';
import { OptionOrChildEventItem } from '../../common/interfaces/event.interface';

interface OptionOrChildEventRowActionsProps {
  index: number;
  lang: LanguageCodeEnum;
  opt: OptionOrChildEventItem;
  fieldName: string;
  eventIcons?: string[];
  replace: (index: number, value: OptionOrChildEventItem) => void;
  onRemove?: (index: number) => void;
  showIconSelector?: boolean;
}

const OptionOrChildEventRowActions: React.FC<OptionOrChildEventRowActionsProps> = ({
  index,
  lang,
  opt,
  fieldName,
  eventIcons,
  replace,
  onRemove,
  showIconSelector
}) => {
  const { errors, touched } = useFormikContext<FormValues>();
  if (lang !== LanguageCodeEnum.ENG) return null;

  const iconError = getIn(errors, `${fieldName}[${index}].icon`);
  const iconTouched = getIn(touched, `${fieldName}[${index}].icon`);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: '-12px' }}>
      {showIconSelector && (
        <IconSelector
          selectedIcon={opt.icon}
          hasError={!!iconTouched && !!iconError}
          availableIcons={eventIcons || []}
          onSelect={icon => replace(index, { ...opt, icon })}
        />
      )}

      {onRemove && (
        <IconButton onClick={() => onRemove(index)}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default OptionOrChildEventRowActions;
